<div class="dialog-wrapper">
    <!-- Head -->
    <div class="head">
      {{data?.addressToUpdate}}
      <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
        <mat-icon matSuffix svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
      </button>
    </div>
    <div class="body" *ngIf="isFormReady">
      <div class="body-container">
          <div class="page-main">
            <div class="page-container">
              <form [formGroup]="form" novalidate class="form-wrapper form-invoice">
                <section class="new-address-book">
                  <div class="form-row">
                    <mat-form-field appearance="outline"
                      class="custom-mat-form-field custom-mat-form-field-outline size size1of1">
                      <mat-label>Address</mat-label>
                      <mat-select (selectionChange)="onChangeAddress($event.value)" [value]="selectedAddress" required disableOptionCentering="true" panelClass="custom-mat-select-panel list-address-books" class="custom-mat-select select-address-books">
                        <mat-select-trigger class="custom-mat-select-trigger heightFixed">
                          <ng-container *ngIf="selectedAddress !== '0' ; else newAddress">
                            <label class="address-contact">
                              <span>{{ selectedAddress?.contactName }}</span>
                            </label>
                            <label class="address-info">
                              <span>{{ selectedAddress?.street1 }} {{ selectedAddress?.street2 }}</span>
                            </label>
                            <label class="address-info">
                              <span>{{selectedAddress?.city}} • {{selectedAddress?.state}} • {{selectedAddress?.zip}} • {{selectedAddress?.country?.alpha2Code}}</span>
                            </label>
                          </ng-container>
                          <ng-template #newAddress>
                            <label class="address-contact">
                              <span>Enter a new address</span>
                            </label>
                          </ng-template>
                        </mat-select-trigger>
                        <mat-option class="option-address option-address-new" value="0">Enter a new address</mat-option>
                        <mat-option *ngFor="let address of collectionOfCustomerAddressBook" [value]="address" class="custom-mat-option option-address">
                          <label class="label-address-nickname">{{address.contactName}}</label>
                          <p matLine>
                            <label class="label-address-info">
                              <span>{{address.street1}} {{address.street2}}</span>
                            </label>
                          </p>
                          <p matLine>
                            <label class="label-address-info">
                              <span>{{address.city}} • {{address.state}} • {{address.zip}} • {{address.country.alpha2Code}}</span>
                            </label>
                          </p>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div [@onRowStatusChange]="statusNewAddressPanel" class="form-row row-new-address">
                    <div class="form-row-group size size1of1">
                      <div  formGroupName="addressData" class="form-row">
                        <mat-form-field class="custom-mat-form-field size size1of1">
                          <mat-label>Address Type</mat-label>
                          <mat-select formControlName="type" class="custom-mat-select">
                            <mat-option *ngFor="let addressType of collectionOfAddressType" [value]="addressType.value" class="custom-mat-option">{{addressType.label}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div formGroupName="addressData" class="form-row">
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input required matInput placeholder="First Name" name="firstName" formControlName="firstName" />
                        </mat-form-field>
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input required matInput placeholder="Last Name" name="lastName" formControlName="lastName" />
                        </mat-form-field>
                      </div>
                      <div formGroupName="addressData" class="form-row">
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input required matInput placeholder="Address" name="street1" formControlName="street1" />
                        </mat-form-field>
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input matInput placeholder="Apartment / Suite / etc." name="street2" formControlName="street2" />
                        </mat-form-field>
                      </div>
                      <div formGroupName="addressData" class="form-row">
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input required matInput placeholder="City" name="City" formControlName="city" />
                        </mat-form-field>
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input required matInput placeholder="State" name="state" formControlName="state" />
                        </mat-form-field>
                      </div>
                      <div formGroupName="addressData" class="form-row">
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <input required matInput placeholder="Zip / Postal Code" name="zip" formControlName="zip" />
                        </mat-form-field>
                        <mat-form-field class="custom-mat-form-field size size1of2">
                          <mat-select required name="country" formControlName="countryId" class="custom-mat-select">
                            <mat-option *ngFor="let country of collectionOfCountry" [value]="country.id"
                              class="custom-mat-option">{{
                              country.name }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-row row-checkbox">
                        <mat-checkbox formControlName="saveAddress" [disabled]="disableSaveAddress" disableRipple="true" color="primary"
                          class="custom-mat-checkbox rounded checkbox-simple-line">Save this address in my address book.</mat-checkbox>
                      </div>
                    </div>
                  </div>
                </section>
              </form>
            </div>
          </div>
      </div>
    </div>

  <!-- Nav -->
  <div class="nav margin nomargin" *ngIf="isFormReady">
    <button mat-flat-button (click)="onSubmit()" color="primary" class="mat-button custom-mat-button-primary">Update Address</button>
  </div>
  <!-- skeleton form-sections -->
  <div *ngIf="!isFormReady">
    <skeleton-loader-form [numberOfInputs]=2></skeleton-loader-form>
  </div>

</div>
